<template>
    <section v-if="modules.length > 0" class="radar-modules-block">
        <div class="radar-modules-container">
            <div v-for="(column, columnIndex) in moduleColumns" :key="columnIndex" class="radar-column">
                <SummaryCard v-for="module in column" :key="module.toolCode" :title-key="module.labelKey" :tool-code="module.toolCode" :icon="module.icon" :show-badge="module.badgeCount > 0" :badge-count="module.badgeCount" :badge-label="module.badgeLabel" :show-badge-dot="module.badgeCount > 0" :items="module.kpis" @item-click="(kpi) => $emit('item-click', kpi)" />
            </div>
        </div>
    </section>
</template>

<script>
import SummaryCard from '../ui/SummaryCard.vue'

/** Altura aproximada (en "unidades" = 1 header + 1 por KPI visible) usada solo para balancear columnas. */
const estimateModuleHeightUnits = (module) => {
    const kpisCount = (module.kpis && module.kpis.length) || 0

    return 1 + kpisCount
}

/**
 * Distribuye los módulos en N columnas con un algoritmo greedy: cada módulo se agrega
 * a la columna con menor altura acumulada. Como todas las columnas parten en 0, los primeros
 * N módulos quedan uno por columna (respetando RADAR_MODULE_ORDER en la primera fila),
 * y el resto se balancea por altura sin dejar huecos grandes (efecto masonry).
 *
 * Nota: el masonry se hace en JS (no CSS) para mantener el orden izquierda→derecha
 * según RADAR_MODULE_ORDER.
 */
const distributeModulesIntoColumns = (modules, columnCount) => {
    const columns = Array.from({ length: columnCount }, () => [])
    const columnHeights = new Array(columnCount).fill(0)

    modules.forEach((module) => {
        let shortestColumnIndex = 0

        for (let i = 1; i < columnCount; i++) {
            if (columnHeights[i] < columnHeights[shortestColumnIndex]) {
                shortestColumnIndex = i
            }
        }

        columns[shortestColumnIndex].push(module)
        columnHeights[shortestColumnIndex] += estimateModuleHeightUnits(module)
    })

    return columns
}

export default {
    name: 'RadarModules',
    components: {
        SummaryCard
    },
    props: {
        modules: {
            type: Array,
            default: () => []
        },
        columnCount: {
            type: Number,
            required: true
        }
    },
    computed: {
        moduleColumns() {
            return distributeModulesIntoColumns(this.modules, this.columnCount)
        }
    }
}
</script>

<style lang="scss" scoped>
.radar-modules-block {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    @media (min-width: 1200px) {
        height: 100%;
    }
}

.radar-modules-container {
    // mobile first: una sola columna (el propio JS ya arma moduleColumns con columnCount = 1)
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 16px;

    // tablet/desktop: columnas reales lado a lado (el número de columnas lo controla columnCount en JS)
    @media (min-width: 768px) {
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
    }

    .radar-column {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;

        // no crece más allá del ancho de la card (425.33px): así el gap entre columnas
        // queda fijo en 16px y el grupo completo se centra en vez de estirarse
        @media (min-width: 768px) {
            flex: 0 1 425.33px;
            max-width: 425.33px;
            min-width: 0;
        }
    }
}
</style>
